import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkStepper from "../../components/atoms/TkStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { httpAPI_RET018 } from "./api/request";
import { fakeTableList, schema, stepper } from "./parts";
import "./_style.scss";
import { Box, Typography } from "@mui/material";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { IAPI_RET018_Request } from "../../type/apiType";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { API_RET018_BuildReqParams } from "../../utils/buildRequestParams";
import _ from "lodash";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { DemanderKbn } from "../../assets/data/Constants";

/**
 * SCRR411120 退職手当金受領者の変更手続き（退職者との続柄の確認）
 * @return SCRR411120
 */
const SCRR411120 = () => {
  const navigate = useNavigate();
  // 認証情報
  const { state, setState } = useContext(GlobalContext);
  // 持回情報
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.job_40;
  const userType = state.authInfo?.userType;
  const isUserTypeKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [selectedRelationShip, setSelectedRelationShip] = useState<string>();
  const [livelihoodFromRetireeFlg, setLivelihoodFromRetireeFlg] =
    useState<string>();
  const [openSuccess, setOpenSuccess] = useState(false);
  const ruleSchemaTest = useRef(schema);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  const splitTextAtPeriods = (
    text: string,
    rule: string | undefined
  ): string[] => {
    if (!text || !rule) return [text];

    const sentences = text.split(rule);
    return sentences;
  };

  // 必要書類に関する文言を取得
  const getTextDocument = (
    selectedRelationShip: string,
    livelihoodFromRetireeFlg: string | undefined
  ) => {
    let msg = "";
    if (selectedRelationShip === "1") {
      msg = labelids.labelid.LBLR411120_04;
    } else if (selectedRelationShip === "2") {
      msg = labelids.labelid.LBLR411120_05;
    } else if (
      Number(selectedRelationShip) > 2 &&
      livelihoodFromRetireeFlg === "1"
    ) {
      msg = labelids.labelid.LBLR411120_06;
    } else if (
      Number(selectedRelationShip) > 2 &&
      livelihoodFromRetireeFlg === "0"
    ) {
      msg = labelids.labelid.LBLR411120_07;
    }
    return (
      <Typography>
        {splitTextAtPeriods(msg, "\\n").map((item, index) => {
          return (
            <Box key={index} className="tkInfoText">
              {item}
            </Box>
          );
        })}
      </Typography>
    );
  };

  useEffect(() => {
    if (selectedRelationShip && selectedRelationShip !== "") {
      let resArr = stateFakeTableList.current;
      // 請求者その他続柄
      let demanderRelationshipOthers = resArr.find(
        (item) => item.keyword === "demanderRelationshipOthers"
      )!;
      // 退職者からの生計維持の有無
      let livelihoodFromRetireeFlgPart = resArr.find(
        (item) => item.keyword === "livelihoodFromRetireeFlg"
      )!;
      // あなたと同順位の請求権保持者の有無
      let demanderFlg = resArr.find((item) => item.keyword === "demanderFlg")!;

      demanderRelationshipOthers.showLine = selectedRelationShip === "8";

      let textDocument = resArr.find(
        (item) => item.keyword === "textDocument"
      )!;
      textDocument.lineTitle = getTextDocument(
        selectedRelationShip,
        livelihoodFromRetireeFlg
      );

      // 子～兄弟姉妹を選択した場合、退職者からの生計維持の有無、あなたと同順位の請求権保持者の有無が必須入力となる
      if (
        Number(selectedRelationShip) > 2 &&
        Number(selectedRelationShip) < 8
      ) {
        livelihoodFromRetireeFlgPart.requiredIcon = true;
        demanderFlg.requiredIcon = true;
      } else {
        livelihoodFromRetireeFlgPart.requiredIcon = false;
        demanderFlg.requiredIcon = false;
      }
      const validateLivelihoodFromRetireeFlg = (data: any) => {
        if (
          !data &&
          Number(selectedRelationShip) > 2 &&
          Number(selectedRelationShip) < 8
        ) {
          return TkPropertyMessageGet("TKMSG_SCR0043E");
        } else {
          return;
        }
      };
      const validateDemanderFlg = (data: any) => {
        if (
          !data &&
          Number(selectedRelationShip) > 2 &&
          Number(selectedRelationShip) < 8
        ) {
          return TkPropertyMessageGet("TKMSG_SCR0043E");
        } else {
          return;
        }
      };
      ruleSchemaTest.current = {
        ...ruleSchemaTest.current,
        livelihoodFromRetireeFlg: {
          validate: validateLivelihoodFromRetireeFlg,
        },
        demanderFlg: {
          validate: validateDemanderFlg,
        },
      };
      setStateTableList([...resArr]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRelationShip, livelihoodFromRetireeFlg]);

  const handleInit = () => {
    let resArr = stateFakeTableList.current;
    if (isUserTypeKiko) {
      let retirementStaffName = resArr.find(
        (item) => item.keyword === "retirementStaffName"
      )!;
      retirementStaffName.showLine = true;
      retirementStaffName.contractorNumber = context?.retirementStaffName;
    }

    // 持回情報.請求者続柄
    let demanderRelationship = resArr.find(
      (item) => item.keyword === "demanderRelationship"
    )!;
    demanderRelationship.setDefaultValue = context?.demanderRelationship;
    demanderRelationship.onGetValue = (data: any) => {
      setSelectedRelationShip(data);
    };
    let newRadioList = demanderRelationship.radioPropsList;
    newRadioList[1].disabled = context?.demanderKbn === DemanderKbn["相続人"];
    demanderRelationship.radioPropsList = newRadioList;
    setSelectedRelationShip(context?.demanderRelationship);

    // 持回情報.請求者その他続柄
    let demanderRelationshipOthers = resArr.find(
      (item) => item.keyword === "demanderRelationshipOthers"
    )!;
    demanderRelationshipOthers.setDefaultValue =
      context?.demanderRelationshipOthers ?? "";

    // 持回情報.退職者からの生計維持の有無
    let livelihoodFromRetireeFlg = resArr.find(
      (item) => item.keyword === "livelihoodFromRetireeFlg"
    )!;
    livelihoodFromRetireeFlg.setDefaultValue =
      context?.livelihoodFromRetireeFlg;
    livelihoodFromRetireeFlg.onGetValue = (data: any) => {
      setLivelihoodFromRetireeFlg(data);
    };
    setLivelihoodFromRetireeFlg(context?.livelihoodFromRetireeFlg);

    // 持回情報.あなたと同順位の請求権保持者の有無
    let demanderFlg = resArr.find((item) => item.keyword === "demanderFlg")!;
    demanderFlg.setDefaultValue = context?.demanderFlg;

    setStateTableList([...resArr]);
  };

  // 初期表示
  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeHttpObj = (obj: any): IAPI_RET018_Request => {
    const reqObj: IAPI_RET018_Request = {
      ...context,
      ...obj,
      tempSaveStep: 2,
      contractorNo: isUserTypeKiko
        ? businessState?.common?.contractorNo
        : state.authInfo?.contractorNo,
      staffNo: context?.staffNo,
      screenId: "SCRR411120", // 画面id
    };

    return API_RET018_BuildReqParams(reqObj);
  };

  const onCheckAndSubmit = async (data: any, index?: number) => {
    const dataObj = {
      demanderRelationship: data.demanderRelationship,
      demanderRelationshipOthers: data.demanderRelationshipOthers,
      demanderFlg: data.demanderFlg,
      livelihoodFromRetireeFlg: data.livelihoodFromRetireeFlg,
    };

    if (index === 0) {
      try {
        // 退職手当金請求更新API呼び出し
        const res = await httpAPI_RET018({
          ...makeHttpObj(dataObj),
        });

        if (res.resultCd === "I0000") {
          setBusinessState({
            ...businessState,
            job_40: {
              ...context,
              ...dataObj,
              applyId: res.applyId,
            },
          });
          setState({
            ...state,
            errorMsgId: "",
          });
          setOpenSuccess(true);
        } else {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
        }
      } catch (error) {
        navigate("/error");
      }
    } else {
      setBusinessState({
        ...businessState,
        job_40: {
          ...context,
          ...dataObj,
        },
      });
      // 画面遷移
      navigate("/SCRR411121");
    }
  };

  return (
    <Box className="SCRR411120" data-testid="SCRR411120PageForTest">
      <TkStepper
        steps={stepper}
        activeStep={1}
        savaStep={context?.tempSaveStep}
      />
      <TkFakeTable
        list={stateTableList}
        ruleSchema={ruleSchemaTest.current}
        onCheckAndSubmit={onCheckAndSubmit}
        buttonGroup={<TkBackButton />}
        submitButtonGroup={[
          { submitButtonText: "一時保存" },
          { submitButtonText: "次へ" },
        ]}
      />

      <TkMessageDialog
        open={openSuccess}
        onOky={() => setOpenSuccess(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />
    </Box>
  );
};

export default SCRR411120;
